import { render, staticRenderFns } from "./ArticlesHighlightCard.vue?vue&type=template&id=20e75c62&scoped=true&"
import script from "./ArticlesHighlightCard.vue?vue&type=script&lang=js&"
export * from "./ArticlesHighlightCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesHighlightCard.vue?vue&type=style&index=0&id=20e75c62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e75c62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
